module.exports = __webpack_public_path__ + "fonts/fa-v2-regular-400.83aa8612.ttf";